import { render } from "./ControleDeProtocolo.vue?vue&type=template&id=d0153ca2&scoped=true"
import script from "./ControleDeProtocolo.vue?vue&type=script&lang=js"
export * from "./ControleDeProtocolo.vue?vue&type=script&lang=js"

import "./ControleDeProtocolo.vue?vue&type=style&index=0&id=d0153ca2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0153ca2"]])

export default __exports__